module.exports = {
	init: function () {
		let personCard = document.querySelectorAll(".item.people");

		if (personCard) {
			personCard.forEach((card) => {
				// get name
				let name = card.querySelector(".name");

				// get .content-wrapper
				let contentWrapper = card.querySelector(".content-wrapper");

				// if there is no bio content, style name with no pointer
				if (!contentWrapper) {
					name.style.cursor = "auto";
				}

				// get close button
				let closeButton = contentWrapper
					? contentWrapper.querySelector(".card-content-close")
					: null;

				// show .content-wrapper when .content-btn is clicked
				if (contentWrapper) {
					name.addEventListener("click", (e) => {
						contentWrapper.classList.add("show");
					});
				}

				// click outside in the black area to exit .content-wrapper
				if (contentWrapper) {
					contentWrapper.addEventListener("click", (e) => {
						e.target.classList.remove("show");
					});
				}

				// press Esc to exit .content-wrapper
				document.addEventListener("keyup", (event) => {
					if (event.key === "Escape") {
						if (contentWrapper.classList.contains("show")) {
							contentWrapper.classList.remove("show");
						}
					}
				});

				// click close button to––you guessed it––close
				if (closeButton) {
					closeButton.addEventListener("click", (event) => {
						event.preventDefault();
						if (contentWrapper.classList.contains("show")) {
							contentWrapper.classList.remove("show");
						}
					});
				}
			});
		}
	},
};
